'use client';
import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    /**
   * Whether or not the card should have a border
   * @default false
   */ bordered: PropTypes.bool,
    /**
   * Whether or not this Card should stretch its height to fill its parent GridContainer Row
   *
   * This is useful if you have a Row of Cards and you want them to all be the same height
   * @default false
   */ evenHeight: PropTypes.bool,
    /**
   * Whether or not the content should expand to the edges of the Card
   * @default false
   */ fullBleed: PropTypes.bool,
    /**
   * Use "link" if you want to render card as a link or <Link> as a Card covering
   */ skin: PropTypes.oneOf([
        'link'
    ])
};
const Card = createComponent({
    displayName: 'Card',
    root: 'div',
    propTypes,
    propConfig: {
        classNames (props) {
            const classNameSet = new Set([
                'swan-card'
            ]);
            const { bordered = false, evenHeight = false, fullBleed = false, skin } = props;
            if (skin === 'link') classNameSet.add('swan-card-skin-link');
            if (bordered) classNameSet.add('swan-card-bordered');
            if (evenHeight) classNameSet.add('swan-card-even-height');
            if (fullBleed) classNameSet.add('swan-card-full-bleed');
            return classNameSet;
        }
    }
});

export { Card };
